module.exports = __webpack_public_path__ + "img/800AD.87cfb7f3.png";